import RoleForm from '../vue/RoleForm.vue'
import { mountRequiredStaffImportModal, mountRoleImportModal } from './modal.js';
import { createApp, ref } from 'vue';
import { deleteGroupRoleRequest, deleteRoleRequest, putRoleRequest } from './role_requests.js';
import { addRoleSectionToRole, addSectionToRole, editSectionFromRole, updateRoleDayRequiredNum, updateRoleEmployeeCount, updateRoleEmployeePos, updateRoleEmployeePriority, updateRoleEvenlyAllocation, updateRoleOverrideDates, updateRoleType, updateRoleWorkEvenlyAllocation } from '../requests/roleRequest';
import ERRORS from './errors.js';
import { MeStore } from '../store/v1/meStore';
import { User } from '../model/v1/user';
import RoleDataForm from '../role/components/RoleDataForm.vue';
import { fromOplusTime, yearMonthDateString } from '../common/common';
import GroupRoleBranchModal from '../view/components/groupRole/components/GroupRoleBranchModal.vue';
import { GroupRolePageApp } from '../app/groupRoleImpl';
import { parseRoleFromAPI, parseSection } from '../parser/roleParser'
import { deleteRoleSectionRequest } from '../requests/sectionRequest';
import timeZones from '../common/timeZones';

let meStore;
const ROLES_FORM = {
  CREATE: "#role-create-form",
}

let isGroupRoleList;
let isGroupOwner = false;

const roleRequiredMap = ref({});
const weekDayRequired = ref({});
const roleRef = ref(null)

export function initPage(props) {
  // Role specific page
  if (props?.renderRoleData) {
    meStore = new MeStore({user: new User({id: props.userId})}, {activeBranchId: props.branchId});
    roleRef.value = parseRoleFromAPI(props.roleData)
    roleRequiredMap.value = makeRoleRequiredMap(props.roleData);
    weekDayRequired.value = (Array.from(props.roleData.DayNumbers));
    mountRolePageApp(props);
  }
  // Roles table page
  if (props?.renderRolesTable) {
    isGroupRoleList = props.isGroupRoleForm;
    isGroupOwner = props.isGroupOwner;
    mountRequiredStaffImportModal(props.roles, props.userId, props.branchId);
    mountRoleImportModal(props.isGroupRoleForm);
    mountRoleForm(props);
    initImportDropdown();
  }

  if (props?.isGroupRoleForm) {
    mountGroupRoleBranchModal(props);
  }
}

export function updateRequiredCalendar(newWeekDayRequired, requiredData = null) {
  if (newWeekDayRequired) {
    weekDayRequired.value = [...newWeekDayRequired];
    roleRef.value.requiredWeekdayNumbers = weekDayRequired.value;
  }
  if (requiredData) {
    roleRequiredMap.value[requiredData.date] = {
      required: parseInt(requiredData.requiredNum) || 0,
      realDate: fromOplusTime(new Date(requiredData.date)),
    };
  }
}

function mountFormComponent(component, mountPoint, props) {
  const app = createApp(component, props);
  window[mountPoint] = app.mount(mountPoint);
}

function mountRoleForm(props) {
  mountFormComponent(RoleForm, ROLES_FORM.CREATE, {
    havePermission: props.havePermission,
    isGroupRoleForm: props.isGroupRoleForm,
    isGroupOwner: props.isGroupOwner,
    selectedOem: props.selectedOem
  });
  $(`${ROLES_FORM.CREATE}-btn .oplus-btn`).on("click", () => {
    roleFormBtnHandler()
  });
}

function mountRolePageApp(props) {
  const app = createApp(RoleDataForm, {
    isGroupRoleForm: props.isGroupRoleForm,
    isGroupOwner: props.isGroupOwner,
    selectedOem: props.selectedOem,
    hasProPerm: props.havePermission.pro,
    hasAutoPerm: props.havePermission.auto,
    hasRolePerm: props.havePermission.role,
    hasKot: props.havePermission.KOT,
  })

  const roleSectionsData = [];
  props.roleSectionData.forEach(r => {
    roleSectionsData.push(parseRoleFromAPI(r))
  })

  let mainRole;
  const subRoles = [];
  if (props.mainRole) {
    mainRole = parseRoleFromAPI(props.mainRole);
  }

  if (props.subRoles) {
    props.subRoles.forEach(s => {
      subRoles.push(parseRoleFromAPI(s))
    })
  }

  app.provide('roleView', roleRef);
  app.provide('roleRequiredMap', roleRequiredMap)
  app.provide('weekDayRequired', weekDayRequired)
  app.provide('roleSectionsData', roleSectionsData)
  app.provide('subRoles', subRoles)
  app.provide('mainRole', mainRole)
  app.provide('activeUserData', { userId: meStore.getActiveUserId(), branchId: meStore.getActiveBranchId() });
  app.mount("#role-page-app")
}

function initImportDropdown() {
  $('#roles-import-toggle-btn').on('click', function(e) {
    e.stopPropagation();
    $('#roles-import-dropdown-menu').toggleClass('active');
  });

  $('#roles-import-modal-btn').on('click', function() {
    $('#roles-import-dropdown-menu').removeClass('active');
  });

  $('#required-staff-import-modal-btn').on('click', function() {
    $('#roles-import-dropdown-menu').removeClass('active');
  });

  $(document).click(function(e) {
    if (!$(e.target).closest('.import-dropdown-wrapper').length) {
      $('#roles-import-dropdown-menu').removeClass('active');
    }
  });
}

function makeRoleRequiredMap(role) {
  const requiredNum = role.vDates;
  const reqMap = {};

  if (requiredNum) {
    requiredNum.forEach(reqData => {
      reqMap[reqData.dateStr] = {
        required: parseInt(reqData.num),
        realDate: fromOplusTime(reqData.dateStr),
      }
    })
  }

  return reqMap
}

export function openRoleFormEdit(roleID) {
  roleFormBtnHandler(roleID);
}

function roleFormBtnHandler(roleID) {
  const roleForm = window[ROLES_FORM.CREATE];
  roleForm.toggleRoleForm(roleID);
  changeRoleCreateBtn(roleForm.isVisible);
}

export function changeRoleCreateBtn(isOpen) {
  if (isOpen) {
    $(`${ROLES_FORM.CREATE}-btn .oplus-btn`).addClass("active");
    $(`${ROLES_FORM.CREATE}-btn-text`).text("閉じる");
    $(`${ROLES_FORM.CREATE}-icon`).addClass("close");
  } else {
    $(`${ROLES_FORM.CREATE}-btn .oplus-btn`).removeClass("active");
    $(`${ROLES_FORM.CREATE}-btn-text`).text("作成");
    $(`${ROLES_FORM.CREATE}-icon`).removeClass("close");
    RolesApp.selectedRoleId = 0;
  }
}

export function rolesImportSuccessCallback(response) {
  if (response.badRows) {
    // Invalid column input
    let errorMessage = "";

    for (const key in response.badRows) {
      errorMessage += `${response.badRows[key]},\n`;
    }
    alertModal.alert(`CSV業務インポートの関数エラー\n\n${errorMessage}`);
  }
  if (response.error) {
    alertModal.alert(errors.ROLE.IMPORT);
    return;
  }
  // Note: the following Fields in Role are the ones being updated on the import:
  // ** START **
  // ID
  // Name
  // Purpose
  // From
  // To
  // Rest
  // Wage
  // IsNightShift
  // NextDayOff
  // Type
  // GroupWide
  // SlotType
  // ShowCount
  // ShowStaffCount
  // IsHiddenInShiftPage
  // ** END **

  // And these are the ones not being updated:
  // ** START **
  // Color
  // DayNumbers
  // Description
  // EmployeePriority
  // Evenly
  // ExternalID
  // IsFromHidden
  // IsRoleSection
  // IsToHidden
  // KOTHolidayType
  // RoleSections
  // Sections
  // WorkEvenly
  // vColor
  // vDates
  // vEdit
  // vEmployees
  // vNumDaysSetting
  // vUnjoined
  // ActiveBranchCount
  // ** END **
  response.roles.forEach(role => {
    const existingRoleIndex = RolesApp.roles.findIndex(oldRole => oldRole.ID === role.ID);
    const existingRole = RolesApp.roles[existingRoleIndex];
    if (existingRoleIndex !== -1) {
      const importedRole = {...role, ...getMissingFieldsFromRoleImport(existingRole)};
      RolesApp.roles.splice(existingRoleIndex, 1); // remove the existing role to keep order
      RolesApp.roles.push(importedRole);
    } else {
      RolesApp.roles.push(role);

      if (RolesApp.isGroupRoleList) {
        RolesApp.setActiveBranchCountForRole(role.ID);
        setNewGroupRoleBranch(role.ID);
      }
    }
  });
  RolesApp.initRoleAlert();
}

function getMissingFieldsFromRoleImport(role) {
  const {
    Color,
    DayNumbers,
    Description,
    EmployeePriority,
    Evenly,
    ExternalID,
    IsFromHidden,
    IsRoleSection,
    IsToHidden,
    RoleSections,
    Sections,
    WorkEvenly,
    vColor,
    vDates,
    vEdit,
    vEmployees,
    vNumDaysSetting,
    vUnjoined,
    ActiveBranchCount,
  } = role
  return {
      Color,
      DayNumbers,
      Description,
      EmployeePriority,
      Evenly,
      ExternalID,
      IsFromHidden,
      IsRoleSection,
      IsToHidden,
      RoleSections,
      Sections,
      WorkEvenly,
      vColor,
      vDates,
      vEdit,
      vEmployees,
      vNumDaysSetting,
      vUnjoined,
      ActiveBranchCount,
  }
}

export function updateRoleFromRolesApp(updatedRole) {
  const role = RolesApp.roles.find(r => r.ID == updatedRole.ID);
  if (!role) {
    return;
  }
  RolesApp.canSubmit = true;
  Object.assign(role, updatedRole);
}

export function getRoleFromRolesApp(roleID) {
  const role = RolesApp.roles.find(r => r.ID == roleID);
  if (!role) {
    return null
  }

  return role;
}

function deleteRoleFromRolesApp(roleId) {
  const i = roleAppToIndex(roleId);
  RolesApp.roles.splice(i, 1);
}

export function deleteRole(roleId) {
  if (isGroupRoleList) {
    if (!isGroupOwner) {
      alertModal.alert("オーナーのみマスター業務を削除できます。");
      return;
    }

    const message = "拠点内で使用している業務を削除した場合、業務カウントに影響を与える可能性があります。削除前に全拠点にて業務が使用されていない事をご確認ください。";
    alertModal.confirmDelete(message, () => {
      return deleteGroupRole(roleId);
    })
  } else {
    alertModal.confirm("本当に消去しますか？", () => {
      return deleteBranchRole(roleId);
    })
  }
}

export async function deleteBranchRole(roleId) {
  try {
    await deleteRoleRequest(roleId);
    deleteRoleFromRolesApp(roleId);
  } catch (err) {
    alertModal.alert(ERRORS.ROLE.DELETE)
  }
}

export async function deleteGroupRole(roleId) {
  try {
    await deleteGroupRoleRequest(roleId);
    deleteRoleFromRolesApp(roleId);
  } catch (err) {
    alertModal.alert(ERRORS.ROLE.DELETE)
  }
}

export async function submitAddRoleSection(parentRoleId, roleSectionId) {
  try {
    const userId = meStore.getActiveUserId();
    const branchId = meStore.getActiveBranchId();
    if (!userId) {
      throw new Error("invalid User ID")
    }
    const payload = {
      roleId: parentRoleId,
      sectionRoleId: roleSectionId,
    }
    const response = await addRoleSectionToRole(userId, branchId, payload);
    if (response?.success) {
      const newSection = parseSection(response.section)
      roleRef.value.roleSections.push(newSection);
    } else {
      throw new Error(response.detail);
    }
  } catch(err) {
    throw err
  }
}

export async function removeRoleSectionFromRole(parentRoleId, roleSectionId) {
  const roleDeleteIcon = $(`#role-section-delete-icon[data-role-sect-id='${roleSectionId}']`);
  roleDeleteIcon.addClass("loading");
  try {
    const userId = meStore.getActiveUserId();
    const activeBranchId = meStore.getActiveBranchId();
    const payload = {
      roleId: parentRoleId,
      sectionRoleId: roleSectionId,
    }
    const response = await deleteRoleSectionFromRole(userId, activeBranchId, payload);
    if (response.success) {
      RoleApp.removeRoleSection(roleSectionId);
    }
  } catch(err) {
    alertModal.alert(err)
  } finally {
    roleDeleteIcon.removeClass("loading");
  }
}


export function openAlertModal(msg, refreshPage = false) {
  alertModal.alert(msg, refreshPage);
}

export function openSuccessModal(msg, refreshPage = false) {
  alertModal.alertSuccess(msg, refreshPage);
}

export function openConfirmModal(msg, callback) {
  alertModal.confirm(msg, callback);
}

function mountGroupRoleBranchModal(props) {
  const app = createApp(GroupRoleBranchModal);
  new GroupRolePageApp(app, props.branchId, props.userId, props.groupId, props.isGroupOwner);

  window["#group-role-branch-modal"] = app.mount("#group-role-branch-modal");
}

export function openGroupRoleBranchModal(roleId) {
  window["#group-role-branch-modal"].openModal(roleId);
}

export function setNewGroupRoleBranch(roleId) {
  window["#group-role-branch-modal"]?.setNewGroupRoleBranch(roleId);
}

export function setActiveBranchCountForRole(roleId, activeBranchCount) {
  if (typeof RolesApp === "undefined") {
    return;
  }

  RolesApp.setActiveBranchCountForRole(roleId, activeBranchCount);
}

// Role page
export async function handleRoleEmployeePositionUpdate(roleId, roleJoinedEmployees) {
  try {
    await updateRoleEmployeePos(meStore.getActiveBranchId(), meStore.getActiveUserId(), roleId, roleJoinedEmployees)
  } catch (err) {
    openAlertModal(err)
  }
}

export async function handleSectionUpdate(payload) {
  let response;
  if (payload.sectionId) {
    response = await editSectionFromRole(meStore.getActiveUserId(), meStore.getActiveBranchId(), payload)
  } else {
    response = await addSectionToRole(meStore.getActiveUserId(), meStore.getActiveBranchId(), payload)
  }

  if (response?.section) {
    const newSection = parseSection(response.section)
    const sections = roleRef.value.sections;
    const roleSections = roleRef.value.roleSections;
    const indexSection = sections.findIndex(s => s.id === newSection.id);
    const indexRoleSection = roleSections.findIndex(s => s.id === newSection.id);

    if (indexRoleSection !== -1) {
      roleSections.splice(indexRoleSection, 1, newSection);
      return;
    }

    if (indexSection === -1) {
      sections.push(newSection)
      return
    }

    sections.splice(indexSection, 1, newSection);
  }
}

export async function  handleRoleEmployeeCountUpdate(roleId, payload) {
  try {
    await updateRoleEmployeeCount(meStore.getActiveBranchId(), meStore.getActiveUserId(), roleId, payload)
  } catch(err) {
    openAlertModal(err)
  }
}

export async function handleRoleDayRequiredUpdate(roleId, payload) {
  try {
    await updateRoleDayRequiredNum(meStore.getActiveBranchId(), meStore.getActiveUserId(), roleId, payload);
  } catch (err) {
    openAlertModal(err)
  }
}

export async function handleRoleWorkEvenlyUpdate(roleId, value) {
  try {
    await updateRoleWorkEvenlyAllocation(meStore.getActiveBranchId(), meStore.getActiveUserId(), roleId, value)
  } catch (err) {
    openAlertModal(err)
  }
}

export async function handleRoleEvenlyUpdate(roleId, value) {
  try {
    await updateRoleEvenlyAllocation(meStore.getActiveBranchId(), meStore.getActiveUserId(), roleId, value)
  } catch (err) {
    openAlertModal(err)
  }
}

export async function handleRoleEmpPriorityUpdate(roleId, value) {
  try {
    await updateRoleEmployeePriority(meStore.getActiveBranchId(), meStore.getActiveUserId(), roleId, value)
  } catch (err) {
    openAlertModal(err)
  }
}

export async function handleRoleTypeUpdate(roleId, value) {
  try {
    await updateRoleType(meStore.getActiveBranchId(), meStore.getActiveUserId(), roleId, value)
    roleRef.value.type = value
  } catch (err) {
    openAlertModal(err)
  }
}


export async function handleRequiredNumberUpdate(roleId, requiredNumData) {
  try {
    const userId = meStore.getActiveUserId();
    const branchId = meStore.getActiveBranchId();
    const dateStr = yearMonthDateString(requiredNumData.realDate, timeZones.ASIA_TOKYO)
    let payload = {
      addDate: dateStr,
      num: requiredNumData.required,
    }

    if (requiredNumData.required === undefined) {
      payload = {
        deleteDate: dateStr,
      }
    }
    const response = await updateRoleOverrideDates(userId, roleId.toString(), branchId, payload);
    if (!response.success) {
      throw new Error("Fail to update override date")
    }
    // If it delete, remove from map
    if (requiredNumData.required === undefined) {
      delete roleRequiredMap.value[dateStr];
      return;
    }

    if (!roleRequiredMap.value?.[dateStr]) {
      roleRequiredMap.value[dateStr] = {
        required: requiredNumData.required,
        realDate: requiredNumData.realDate,
      }
    }

    roleRequiredMap.value[dateStr].required = requiredNumData.required;
  } catch (err) {
    openAlertModal(err)
  }
}

export async function handleSectionDelete(sectionId, roleId) {
  try {
    await deleteRoleSectionRequest(meStore.getActiveUserId(), meStore.getActiveBranchId(), sectionId, roleId)
    const sections = roleRef.value.sections;
    const roleSections = roleRef.value.roleSections;
    const indexSection = sections.findIndex(s => s.id === sectionId);
    const indexRoleSection = roleSections.findIndex(s => s.id === sectionId);

    if (indexSection !== -1) {
      sections.splice(indexSection, 1);
      return
    }

    if (indexRoleSection !== -1) {
      roleSections.splice(indexRoleSection, 1);
      return;
    }

  } catch (err) {
    throw err
  }
}

export async function putAndUpdateSharedRoleData(roleId, payload) {
  try {
    const response = await putRoleRequest(roleId, payload)
    if (response.role) {
      const newRole = parseRoleFromAPI(response.role);
      roleRef.value.name = newRole.name
      roleRef.value.color = newRole.color
      roleRef.value.kotHolidayType = newRole.kotHolidayType
      roleRef.value.externalID = newRole.externalID
      roleRef.value.isNightShift = newRole.isNightShift
      roleRef.value.evenly = newRole.evenly
      roleRef.value.workEvenly = newRole.workEvenly
      roleRef.value.nextDayOff = newRole.nextDayOff
      roleRef.value.showCount = newRole.showCount
      roleRef.value.isCountFixed = newRole.isCountFixed
      roleRef.value.showStaffCount = newRole.showStaffCount
      roleRef.value.type = newRole.type
      roleRef.value.slotType = newRole.slotType
    }
  } catch (err) {
    openAlertModal(ERRORS.ROLE.UPDATE)
  }
}

export async function updateShowCount(role, showCount, isGroupRoleForm, isGroupOwner) {
  let value = role.ShowCount;
  const payload = {
    showCount: showCount,
    editSharedSettings: isGroupRoleForm && isGroupOwner,
  };

  try {
    const response = await putRoleRequest(role.ID, payload);
    if (response?.role) {
      value = response.role.ShowCount
    }

  } catch {
    alertModal.alert(ERRORS.ROLE.UPDATE);
  }

  RolesApp.setShowCount(role.ID, value);
}

export async function updateShowStaffCount(role, showStaffCount, isGroupRoleForm, isGroupOwner) {
  let value = role.ShowStaffCount;
  const payload = {
    showStaffCount: showStaffCount,
    editSharedSettings: isGroupRoleForm && isGroupOwner,
  };

  try {
    const response = await putRoleRequest(role.ID, payload);
    if (response?.role) {
      value = response.role.ShowStaffCount;
    }

  } catch {
    alertModal.alert(ERRORS.ROLE.UPDATE);
  }

  RolesApp.setShowStaffCount(role.ID, value);
}

export function updateRoleDayOverride(rawRole) {
  roleRequiredMap.value = makeRoleRequiredMap(rawRole);
}

export function csvImportErrorCallback(response) {
  if (response?.status === 400 && response?.responseJSON?.detail) {
    openAlertModal(response.responseJSON.detail);
    return;
  }

  openAlertModal("CSVインポートができませんでした。ページを更新して再度お試しください。");
}
